/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventlocationunconfirmed2Inputs */

const en_eventlocationunconfirmed2 = /** @type {(inputs: Eventlocationunconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We found the venue but not on the map. Please check the address and pick a suggestion.`)
};

const de_eventlocationunconfirmed2 = /** @type {(inputs: Eventlocationunconfirmed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den Ort haben wir gefunden, aber nicht auf der Karte. Bitte prüf die Adresse und wähl einen Vorschlag.`)
};

/**
* | output |
* | --- |
* | "We found the venue but not on the map. Please check the address and pick a suggestion." |
*
* @param {Eventlocationunconfirmed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventlocationunconfirmed2 = /** @type {((inputs?: Eventlocationunconfirmed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventlocationunconfirmed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventlocationunconfirmed2(inputs)
	return de_eventlocationunconfirmed2(inputs)
});
export { eventlocationunconfirmed2 as "eventLocationUnconfirmed" }